<div class="divider-container">
  <div></div>
  <p>{{ text }}</p>
  <div></div>
</div>